import { Card } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const FormContainer = styled.div`
    padding: 20px 60px;
    
    .title {
        text-align: center;
        font-weight: bold;
        font-size: 22px;
    }
`;

const Logo = styled.div`
    position: absolute;
    top: -30px;
    left: 50%;
    margin-bottom: 30px;
    transform: translate(-50%, -100%);
    font-size: 40px;
    font-weight: bold;
    width: 200px;

    img {
        display: block;
        width: 100%;
    }
`;

export default function FormTemplate({children, title, ...props}) {
    return (
        <Wrapper {...props}>
            <Card style={{ width: "600px" }}>
                <Card.Body>
                    <FormContainer>
                        <div className="form-cont">
                            <Logo>
                                <img src={process.env.PUBLIC_URL + "/image/img_logo_digilog.svg"} alt="" />
                            </Logo>

                            <Outlet/>
                        </div>
                    </FormContainer>
                </Card.Body>
            </Card>
        </Wrapper>
    );
}